// extracted by mini-css-extract-plugin
module.exports = {"Announcement":"Announcement_Announcement__lw3cR"};